var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoodAfter = function SvgMoodAfter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.36 16.06A8.03 8.03 0 1 0 5 0a1 1 0 0 0-1 1v.88h.88a1 1 0 0 0 .48.12 6.03 6.03 0 1 1 0 12.06 1 1 0 0 0-.48.12H4v.88a1 1 0 0 0 1.18.98l.18.02ZM6 12.42v-1.76H4v1.76h2ZM6 5.4V3.64H4v1.75h2Zm0 3.52V7.15H4v1.76h2Z",
    clipRule: "evenodd"
  })));
};
export default SvgMoodAfter;